import {useMutation, UseMutationOptions} from '@tanstack/react-query'
import {useEffect, useState} from 'react'

const DELAY_IN_MS = 500

export const useDelayedLoadingMutation = <TData, TError, TVariables, TContext>(
  mutationOptions: UseMutationOptions<TData, TError, TVariables, TContext>
) => {
  const [isDelayedLoading, setIsDelayedLoading] = useState(false)

  const mutation = useMutation({
    ...mutationOptions,
    onSettled: (data, error, variables, context) => {
      mutationOptions.onSettled?.(data, error, variables, context)
      setIsDelayedLoading(false)
    }
  })

  useEffect(() => {
    let timer: ReturnType<typeof setTimeout> | null = null

    if (mutation.isPending) {
      timer = setTimeout(() => setIsDelayedLoading(true), DELAY_IN_MS)
    } else {
      setIsDelayedLoading(false)
    }

    return () => {
      if (timer) clearTimeout(timer)
    }
  }, [mutation.isPending])

  return {...mutation, isDelayedLoading}
}
